// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function KassaMiddle(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            children: "Упростите процессы",
            className: "h4 lg:h2 text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Поручите рутинную работу по выдаче чеков роботам",
            className: "paragraph-large lg:h-light text-center text-black-landing mt-2"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "shrink-0 mr-4",
                        src: StaticAsset.src("/static/icons/cashier-black-32.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h4", {
                            children: "Чеки передаются оператору фискальных данных онлайн",
                            className: "h6 lg:h4 text-black-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Чеки фискализируются и передаются оператору фискальных данных онлайн.",
                            className: "paragraph text-gray-landing mt-2"
                          })
                        ],
                        className: "lg:w-84"
                      })
                    ],
                    className: "flex justify-between mt-6 lg:mt-0 lg:w-96"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "shrink-0 mr-4",
                        src: StaticAsset.src("/static/icons/papers.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h4", {
                            children: "Автоматические смены ускорят вам процессы",
                            className: "h6 lg:h4 text-black-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Не нужно открывать или закрывать смены вручную, система сама настроит их работу.",
                            className: "paragraph text-gray-landing mt-2"
                          })
                        ],
                        className: "lg:w-84"
                      })
                    ],
                    className: "flex justify-between mt-6 lg:mt-10 lg:w-96"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "shrink-0 mr-4",
                        src: StaticAsset.src("/static/icons/integration.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h4", {
                            children: "Отправляйте чеки покупателям легко",
                            className: "h6 lg:h4 text-black-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Автоматическая отправка чеков покупателю на e-mail, в мессенджер или по смс.",
                            className: "paragraph text-gray-landing mt-2"
                          })
                        ],
                        className: "lg:w-84"
                      })
                    ],
                    className: "flex justify-between mt-6 lg:mt-10 lg:w-96"
                  })
                ],
                className: "lg:w-96"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("img", {
                  className: "lg:absolute lg:max-w-none lg:left-6.5",
                  alt: "kassa integration",
                  src: StaticAsset.src("/static/images/kassa-integration.svg")
                }),
                className: "relative lg:w-148"
              })
            ],
            className: "flex m-auto mt-10 lg:mt-30 flex-col-reverse lg:flex-row lg:justify-between lg:w-252"
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-10 lg:mt-30",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          }),
          JsxRuntime.jsx("p", {
            children: "Уже пользуются 125 предпринимателей",
            className: "paragraph-small text-center text-gray-landing mt-4"
          })
        ],
        className: "py-10 lg:py-30"
      }),
      JsxRuntime.jsx("h3", {
        children: "Попробуйте уже сегодня",
        className: "h4 lg:h2 text-center text-black-landing mt-10 lg:mt-30"
      }),
      JsxRuntime.jsx("p", {
        children: "ККМ Бухта подходит для всех видов бизнеса. Если вы сомневаетесь подойдет ли она вам - просто подайте заявку, и наш менеджер поможет вам понять, как вы можете улучшить свои процессы с ее помощью.",
        className: "paragraph-large lg:h-light text-center flex m-auto mt-2 lg:w-200 text-black-landing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "bag color",
                src: StaticAsset.src("/static/icons/bag-color.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Интернет-магазинам",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Автоматизируйте работу своего интернет-магазина, выбивайте чеки и автоматически сдавайте отчетность.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "handbag",
                src: StaticAsset.src("/static/icons/handbag.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Магазинам",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Настройте отправку чеков клиентам на e-mail и избавьтесь от чеков и очередей на кассе.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "parking",
                src: StaticAsset.src("/static/icons/parking.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Сервисам",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Выдавайте чеки за парковку или продажу билетов. Бухгалтер-кассир больше не нужен.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "payment",
                src: StaticAsset.src("/static/icons/payment.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Платежным организациям",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Автоматизируйте выдачу чеков в ваших системах при проведении оплаты.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "plate",
                src: StaticAsset.src("/static/icons/plate.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Ресторанам и кафе",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Интегрируйте нашу кассу в свое приложение, и ваши посетители будут видеть чеки в истории каждого заказа.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "taxi color",
                src: StaticAsset.src("/static/icons/taxi-color.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Такси",
                className: "h6 lg:h4 text-black-landing mt-2 lg:mt-6"
              }),
              JsxRuntime.jsx("p", {
                children: "Выдавайте чеки прямо в приложении такси или отправляйте их клиентам.",
                className: "paragraph-small lg:paragraph-large text-gray-landing mt-2"
              })
            ],
            className: "w-39 sm:w-48 lg:w-96 lg:px-8 mt-4 lg:mt-20"
          })
        ],
        className: "flex m-auto justify-between flex-wrap lg:w-304"
      })
    ],
    className: "px-6 sm:px-48 lg:px-0 bg-kassa"
  });
}

const make = KassaMiddle;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
